/** 1000 NOK per fund is just something we came up with */
const initialFundPrice = 1000;

export default initialFundPrice;
